
import * as actions from "../action"
import {put} from "redux-saga/effects"

export function* getRegisterRequest(action) {
  let a = ['dasdsa'];
  yield put(actions.getRegisterSuccess(a));
}